import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadPropertyDocuments } from 'src/components/ui/UploadDocument';
import { TAssetInvestmentDetailsSchema } from '@brickwise/asset-validation/dist/asset/investmentData';

interface Props {
  disabled?: boolean;
}

export const ScenarioCalculationsUploader: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext<TAssetInvestmentDetailsSchema>();
  const fieldName = 'documents.scenarioCalculations';

  return (
    <UploadPropertyDocuments
      disabled={disabled}
      showDivider={false}
      headline={t('dashboard.assets.addedit.investment.investorSettings.scenarioCalculations.label')}
      fileUrl={formik.values.documents?.scenarioCalculations ?? ''}
      setFileUrl={(fileUrl) => formik.setFieldValue(fieldName, fileUrl)}
      fieldName={fieldName}
    />
  );
};
